import { TAccount } from '@helpers/Accounts/accounts.types';
import { getTopUpStatus } from '@helpers/GetTopUpStatus/getTopUpStatus';
import { TTopUpStatus } from '@helpers/GetTopUpStatus/getTopUpStatus.types';
import { fetchGetAccounts, fetchGetApplication } from '@iwoca/lapi-client/edge';
import { useQuery } from '@tanstack/react-query';

import { useStateKey } from '../../../../iwQueryClient/useStateKey';

type TData = {
    topUpStatus: TTopUpStatus;
    approvalAmount: number;
    interestRate: number;
    timeoutDate: string;
};
export const useGetInterestOnlyExtensionApprovedBannerData = (
    accountId: NonNullable<TAccount['account_id']>
): TData => {
    const stateKey = useStateKey();

    const { data: account } = useQuery({
        queryKey: ['accounts', stateKey],
        queryFn: () => fetchGetAccounts({ stateKey }),
        select: (data) =>
            data.data.accounts.find(
                (account) => account.account_id === accountId
            ),
        suspense: true
    });
    const { data: applicationResponse } = useQuery({
        queryKey: ['application', stateKey],
        queryFn: () =>
            fetchGetApplication({
                stateKey
            }),
        suspense: true
    });
    if (!applicationResponse) {
        throw new Error();
    }
    if (!account) {
        throw new Error();
    }
    return {
        topUpStatus: getTopUpStatus(account, applicationResponse.data),
        approvalAmount: account.latest_formal_offer.available_cash!,
        timeoutDate: account.latest_formal_offer.timeout!,
        interestRate: account.latest_formal_offer.interest_rates![0].rate!
    };
};
